// File for logic corresponding to photo-gallery-carousel component
import { Component } from 'js-component-framework';
import 'slick-carousel';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import './photo-gallery-carousel.scss';

/**
 * Component for photo-gallery-carousel
 */
export default class PhotoGalleryCarousel extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    const { articleContent, enlargedGroup, adCloseButton } = this.children;

    this.slideView = 0;
    this.closeInterstitialAd = this.closeInterstitialAd.bind(this);
    this.shouldCloseInterstitialAd = this.shouldCloseInterstitialAd.bind(this);

    $(enlargedGroup).slick(this.options.slickEnlarged);
    $(articleContent).slick(this.options.slickThumbs);

    this.triggerInterstitialAd();
    this.intNavigateByThumb();
    this.fixArrowsPosition();

    adCloseButton.addEventListener('click', this.closeInterstitialAd);
  }

  /**
   * Trigger a interstitial advertisement.
   */
  triggerInterstitialAd() {
    const { enlargedGroup, interstitialAd } = this.children;

    $(enlargedGroup).on('afterChange', () => {
      this.slideView += 1;

      if (5 === this.slideView) {
        this.element.classList.add(this.options.adLockClass);
        interstitialAd.removeAttribute('aria-hidden');
        interstitialAd.removeAttribute('tabindex');
        // TODO: trigger ad refresh. See LAK-775
      }
    });
  }

  /**
   * Close the interstitial advertisement.
   */
  closeInterstitialAd() {
    const { interstitialAd } = this.children;

    this.element.classList.remove(this.options.adLockClass);
    interstitialAd.setAttribute('aria-hidden', true);
    interstitialAd.setAttribute('tabindex', '-1');
    this.slideView = 0;
  }

  /**
   * Initialize navigation using thumbnails.
   */
  intNavigateByThumb() {
    const { articleContent, enlargedGroup } = this.children;

    $(articleContent).on('click', '.slick-slide', (event) => {
      $(enlargedGroup).slick(
        'slickGoTo',
        $(event.currentTarget).data('slick-index'),
      );
    });
  }

  /**
   * Determine if interstitial ad should be closed.
   */
  shouldCloseInterstitialAd() {
    if (! this.element.classList.contains(this.options.adLockClass)) {
      return;
    }
    this.closeInterstitialAd();
  }

  /**
   * Fix the arrows position when `appendArrows` slick option is set to a
   * element within 'slick-slider'
   *
   * @link https://github.com/kenwheeler/slick/issues/3657
   * @see `slickOptionsSidebar`
   */
  fixArrowsPosition() {
    const { enlargedGroup } = this.children;

    // Add position relative to image thumb wrapper.
    $(enlargedGroup)
      .find('.article-list__article-image-wrapper')
      .css('position', 'relative');

    // Rebind click handler for navigation.
    $(enlargedGroup).find('.slick-prev').on('click', () => {
      $(enlargedGroup).slick('slickPrev');
      this.shouldCloseInterstitialAd();
    });

    $(enlargedGroup).find('.slick-next').on('click', () => {
      $(enlargedGroup).slick('slickNext');
      this.shouldCloseInterstitialAd();
    });
  }
}
